import React, { useState, useEffect } from 'react';
import './App.scss';
import Header from './components/Header';
import Footer from './components/Footer';
import { getApiVersion, getMetadata, queryIndexes, setParamsValues } from './actions/initialActions';
import DiseaseInjuries from './components/DiseaseInjuries';
import ExternalCauses from './components/ExternalCauses';
import DrugsTable from './components/DrugsTable';
import NeoplasmsTable from './components/NeoplasmsTable';
import { Spinner } from 'reactstrap';
import { RootStateOrAny, useSelector } from 'react-redux';
import CDCHeader from './components/CDCHeader';

function App() {

    const [modal, setModal] = useState(false);

    const toggleModal = () => setModal(!modal);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const query = params.get('query');
        const fy = params.get('fy');
        getApiVersion();
        setParamsValues(query ? query : '', fy);
        getMetadata().then(() => {
            if (query) {
                queryIndexes(query, fy);
            }
        })
    }, [])

    const externalCausesQueryInProgress = useSelector((state: RootStateOrAny) => state.externalCausesQueryInProgress)
    const diseaseInjuriesQueryInProgress = useSelector((state: RootStateOrAny) => state.diseaseInjuriesQueryInProgress)
    const drugsTableQueryInProgress = useSelector((state: RootStateOrAny) => state.drugsTableQueryInProgress)
    const neoplasmsTableQueryInProgress = useSelector((state: RootStateOrAny) => state.neoplasmsTableQueryInProgress)
    const externalCausesCount = useSelector((state: RootStateOrAny) => state.externalCausesCount)
    const diseaseInjuriesCount = useSelector((state: RootStateOrAny) => state.diseaseInjuriesCount)
    const drugsTableCount = useSelector((state: RootStateOrAny) => state.drugsTableCount)
    const neoplasmsTableCount = useSelector((state: RootStateOrAny) => state.neoplasmsTableCount)

    const resultsBody = () => {
        if (externalCausesCount === 0 && diseaseInjuriesCount === 0 && drugsTableCount === 0 && neoplasmsTableCount === 0) {
            return (<div className="font-weight-bold text-center">No results found</div>)
        }
        return (
            <section role="main" className="container-fluid results-container py-3">
                <DiseaseInjuries />
                <ExternalCauses />
                <DrugsTable />
                <NeoplasmsTable />
            </section>
        )
    }

    return (
        <div className={modal ? 'has-modal' : ''}>
            <CDCHeader />
            <Header modal={modal} toggleModal={toggleModal} />

            { externalCausesQueryInProgress || diseaseInjuriesQueryInProgress || drugsTableQueryInProgress || neoplasmsTableQueryInProgress ?
                <section role="main" className="container-fluid">
                    <div className="text-center">
                        <Spinner size="lg" color="dark" />
                    </div>
                </section> :  resultsBody()
            }
            <Footer />
        </div>
    );
}

export default App;
